export function open(item, onclose) {
  return {
    type: "DENOMINATOR_OPEN",
    item,
    onclose
  }
}

export function close() {
  return {
    type: "DENOMINATOR_CLOSE"
  }
}

export function accept() {
  return {
    type: "DENOMINATOR_ACCEPT"
  }
}

export function changeDenomination(item) {
  return {
    type: "DENOMINATOR_CHANGE",
    item
  }
}

export function lock() {
  return {
    type: "DENOMINATOR_LOCK"
  }
}

export function unlock() {
  return {
    type: "DENOMINATOR_UNLOCK"
  }
}
